import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IBasicCenterListResponse, IAppState } from '@nkr/store/index';
import { ICenterBase, ICenter } from '@nkr/models/index';
import { IDashPwlJugBilling } from '@nkr/models/index';
import { IDashPwlJugBillingResponse } from '@nkr/store/reports';
import Filter from './filter';
import Grid from './grid'
import PwlNav from '../nav';

interface BillingPayload {
    centerId: number,
    startDate: string,
    endDate: string
}

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getPwlJugBillingData: (startDate: string, endDate: string, isLatestSearch: boolean, centerId: number) => Promise<IDashPwlJugBillingResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    includeDash: boolean,
    includeNkr: boolean,
    centerList: ICenterBase[],
    jugData: IDashPwlJugBilling[],
    centerId: number,
    startDate: string,
    endDate: string
}

const previousFirstDate = () => {
    var d = new Date();
    d.setDate(0); // set to last day of previous month
    d.setDate(1); // set to the first day of that month

    return d.toISOString().split('T')[0];
}

const previousEndDate = () => {
    var d = new Date();
    d.setDate(0); // set to last day of previous month
    return d.toISOString().split('T')[0];
}

class DashPWLJugBilling extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        includeDash: false,
        includeNkr: true,
        centerList: [],
        jugData: [],
        startDate: previousFirstDate(),
        endDate: previousEndDate()
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("sites[]=dash"));
        let cookies = new Cookies();
        cookies.remove("dashview", {path: '/'});

        let { centerId: centerNum } = this.props;

        let payload: BillingPayload = {
            centerId: centerNum !== null || centerNum > 0 ? centerNum : 0,
            startDate: parsed.startDate !== null && parsed.startDate !== undefined && parsed.endDate !== "" ? parsed.startDate : this.state.startDate,
            endDate: parsed.endDate !== null && parsed.endDate !== undefined && parsed.endDate !== "" ? parsed.endDate : this.state.endDate,
        }

        let { startDate, endDate, centerId } = payload;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getBasicCenterList(),
                this.props.getPwlJugBillingData(startDate, endDate, false, centerId)
            ])
                .then(([centerListResponse, jugResponse]) => {
                    let { results: centerList } = centerListResponse.data;
                    let { reportResults: jugData } = jugResponse.data.results;

                    this.setState({
                        centerList,
                        startDate,
                        endDate,
                        jugData,
                        centerId
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                }).catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleFilter = () => {
        let { startDate, endDate, centerId } = this.state;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            this.props.getPwlJugBillingData(startDate, endDate, false, centerId)
                .then(jugResponse => {
                    let { reportResults: jugData } = jugResponse.data.results;

                    this.setState({
                        jugData,
                        centerId
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleFilterChange = (startDate: string, endDate: string, centerId: number) => {
        this.setState({
            startDate,
            endDate,
            centerId
        });
    }

    setConversionUrl = () => {
        let { startDate, endDate } = this.state;

        let paramList = [];

        if (startDate !== null && startDate !== '' && startDate !== undefined) {
            paramList.push(encodeURI('startDate=' + startDate));
        }

        if (endDate !== null && endDate !== '' && startDate !== undefined) {
            paramList.push(encodeURI('endDate=' + endDate));
        } 

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/pwl-jugbilling?' + params;

        window.history.pushState({}, '', newUrl);
    }

    render = () => {
        return (
            <>
                <PwlNav activeKey='JUG-BILLING' centerId={this.props.centerId} isAdmin={this.props.isAdmin} />

                <Filter
                    isAdmin={this.props.isAdmin}
                    centerId={this.state.centerId}
                    includeDash={this.state.includeDash}
                    includeNkr={this.state.includeNkr}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    centerList={this.state.centerList}
                    onFilterChange={this.handleFilterChange}
                    onFilter={this.handleFilter}
                />

                <Grid
                    jugData={this.state.jugData}
                    centerId={this.state.centerId}
                    isAdmin={this.props.isAdmin}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getPwlJugBillingData: (startDate, endDate, isLatestSearch, centerId) => {
            return dispatch(ReportActionCreators.getPwlJugBillingData(startDate, endDate, isLatestSearch, centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DashPWLJugBilling);